import { useSelector } from 'react-redux';

import Onboarding from './OnboardingV2/Onboarding';
import RecurringHomePage from './RecurringPage/RecurringHomePage';

const Home = () => {
	const onboarding = useSelector((state) => state.instruction);
	const isEnterpriseUser = useSelector((state) => state.user.planName) === 'EnterprisePackage';
	const isOnboarded = onboarding.isOnboarded;

	return <>{isOnboarded || isEnterpriseUser ? <RecurringHomePage /> : <Onboarding />}</>;
};

export default Home;
